import { useEffect } from 'react';

export const useClearSelectionOnUnmount = (onClearSelection: () => void) => {
	useEffect(() => onClearSelection, [onClearSelection]);
};
